import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {isDevQuan}      from "@Common/ui-components/debug/is-dev-quan";

import {ExistingOrderSessionModal} from "./existing-order-session-modal/existing-order-session-modal";

export const PromptStartNewOrder = ({next}) => cs(
    ["existingOrderSessionModal", ({}, next) => ExistingOrderSessionModal({next})],

    ({existingOrderSessionModal}) => next(({existingOrderSessionInfo}) => new Promise((resolve, reject) => {
        if (isDevQuan()) {
            return resolve(true);
        }

        if (!existingOrderSessionInfo.orderID) {
            resolve(true);
        } else {
            existingOrderSessionModal.show({
                existingOrderSessionInfo,
                onSelect: (startNewOrder) => resolve(startNewOrder),
            });
        }
    })),
);

